<h2 mat-dialog-title>Nuovo utente (WSO2)</h2>
<mat-dialog-content>
  <form [formGroup]="form" class="nuovo-utente-form">
    @if (errorMessage) {
      <p class="text-danger mb-3">{{ errorMessage }}</p>
    }
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" />
      @if (form.get('username')?.hasError('required') && form.get('username')?.touched) {
        <mat-error>Obbligatorio</mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nome</mat-label>
      <input matInput formControlName="nome" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Cognome</mat-label>
      <input matInput formControlName="cognome" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Email</mat-label>
      <input matInput type="email" formControlName="email" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password" />
      @if (form.get('password')?.hasError('required') && form.get('password')?.touched) {
        <mat-error>Obbligatorio</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Annulla</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="form.invalid || submitting">
    {{ submitting ? 'Creazione...' : 'Crea utente' }}
  </button>
</mat-dialog-actions>
